module.exports = __webpack_public_path__ + "img/ic-telegram.57a951f9.svg";